module.exports = __webpack_public_path__ + "img/03-thumb.eea2a9ad.jpg";